<ng-container *ngIf="variant === 'horizontal-style-1'">
    <navbar-horizontal-style-1 [userInfo]="userInfo"></navbar-horizontal-style-1>
</ng-container>

<ng-container *ngIf="variant === 'vertical-style-1'">
    <navbar-vertical-style-1 [userInfo]="userInfo"></navbar-vertical-style-1>
</ng-container>

<ng-container *ngIf="variant === 'vertical-style-2'">
    <navbar-vertical-style-2 [userInfo]="userInfo"></navbar-vertical-style-2>
</ng-container>
<ng-container *ngIf="variant === 'vertical-style-dynamic'">
    <fuse-vertical-dynamic [RefVerticalNavbarStyleComponent]="fuseConfig.layout.navbar.dynamicVarientComponent" ></fuse-vertical-dynamic>
</ng-container>
